export const defaultSheetProps = {
  defaultCellHeight: 40,
  headerBackgroundColor: 'rgb(0,166,164)',
  errorHeaderBackgroundColor: 'rgb(166,0,0)',
  headerTextColor: 'rgb(255,255,255)',
  headerTextAlign: 'center',
  toolbarProps: {
    insert: false,
    data: false,
    home: ['exportAs', ['cut', 'copy', 'paste']],
  },
};

export const defaultHeaders = {
  columnHeadersArray: [
    { name: 'Experience Name', modelKey: 'playerName' },
    { name: 'Channel Type', modelKey: 'channelType' },
    { name: 'Traffic Type', modelKey: 'trafficType' },
    { name: 'Campaign Name', modelKey: 'campaignName' },
    { name: 'Campaign Objective Type', modelKey: 'campaignObjectiveType' },
    { name: 'Handle', modelKey: 'handle' },
    { name: 'Platform Type', modelKey: 'platformType' },
    { name: 'Ad Placement Type', modelKey: 'placementType' },
    { name: 'Ad Unit Type', modelKey: 'adUnitType' },
    { name: 'Target Audience', modelKey: 'audienceName' },
    { name: 'Ad Unit Creative Name', modelKey: 'adCreativeName' },
    { name: 'DCM Tracking?', modelKey: 'appendDcmSiteId' },
    { name: 'Client Assigned ID', modelKey: 'clientAssignedId' },
    { name: 'Query Parameter', modelKey: 'additionalParameters' },
    { name: 'Final URL', modelKey: 'launchUrl' },
    { name: 'Errors', modelKey: 'error' },
  ],
};

export const firebaseParamsDict = {
  // Some query params naming conventions differ between launchModel <>
  // what we actually append to the URL and store in Firebase.
  attachCampaignName: 'campaignName',
  adPlacementType: 'placementType',
  paidAudienceType: 'audienceName',
  adUnitCreative: 'adCreativeName',
  siteId: 'appendDcmSiteId',
};

export const dataIdSvcParamsDict = {
  // Some query params naming conventions differ between launchModel <>
  // what we actually append to the URL and store in Firebase.
  campaignName: 'attachCampaignName',
  placementType: 'adPlacementType',
  audienceName: 'paidAudienceType',
  adCreativeName: 'adUnitCreative',
};

// Maps DraftCampaignMetadata keys with corresponding Bulk Link Header indices
export const bulkLinkHeaderIndices = {
  'playerId': 0,
  'attachCampaignName': 1,
  'campaignObjectiveType': 2,
  'handle': 3,
  'platformType': 4,
  'adPlacementType': 5,
  'adUnitType': 6,
  'paidAudienceType': 7,
  'adUnitCreative': 8,
  'appendDcmSiteId': 9,
  'clientAssignedId': 10,
  'additionalParameters': 11,
};

export const dataIdSvcErrorDict = {
  attachCampaignName: { name: 'Campaign Name' },
  campaignObjectiveType: { name: 'Campaign Objective Type' },
  handle: { name: 'Handle' },
  platformType: { name: 'Platform Type' },
  adPlacementType: { name: 'Ad Placement Type' },
  adUnitType: { name: 'Ad Unit Type' },
  paidAudienceType: { name: 'Target Audience' },
  adUnitCreative: { name: 'Ad Unit Creative Name' },
  appendDcmSiteId: { name: 'DCM Tracking?' },
  clientAssignedId: { name: 'Client Assigned Id' },
  additionalParameters: { name: 'Query Parameter' },
};

export const dataKeyMappings = {
  adPlacementType: 'placementType',
  adUnitCreative: 'adCreativeName',
  adUnitType: 'adUnitType',
  attachCampaignName: 'campaignName',
  campaignObjectiveType: 'campaignObjectiveType',
  channelType: 'channelType',
  handle: 'handle',
  paidAudienceType: 'audienceName',
  platformType: 'platformType',
  trafficType: 'trafficType',
  playerId: 'playerId',
};
